import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', background: '#e3eafc' }}>
    <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #039be51a', padding: '40px 32px', minWidth: 320, maxWidth: 400, textAlign: 'center' }}>
      <h1 style={{ color: '#d32f2f', fontWeight: 800, fontSize: '2.5rem', marginBottom: 12 }}>404</h1>
      <h2 style={{ color: '#039be5', fontWeight: 700, marginBottom: 18 }}>Page Not Found</h2>
      <p style={{ color: '#555', fontSize: '1.08rem', marginBottom: 24 }}>
        Sorry, the page you are looking for does not exist.<br />
        It may have been moved or deleted.
      </p>
      <Link to="/" style={{ display: 'inline-block', background: '#039be5', color: '#fff', fontWeight: 700, padding: '12px 32px', borderRadius: 8, textDecoration: 'none', fontSize: '1.08rem', marginTop: 18 }}>
        Go to Home
      </Link>
    </div>
  </div>
);

export default NotFoundPage; 